import { useRef } from "react";
import {
    ReviewsGrid,
    ReviewsHeading,
    ReviewsSection,
} from "@/components/shared";
import { adoptionLabel, type Review } from "@/components/shared/ReviewsSection";
import { useScrollFade } from "@/components/shared/useScrollFade";
import { ReviewsReadMoreLink, ReviewsScrollArrows } from "../reviews-controls";

export function ProviderReviewsSection({
    reviews,
    reviewCount,
    organizationId,
    showHeading = true,
}: {
    reviews: Review[];
    reviewCount: number;
    organizationId?: string;

    showHeading?: boolean;
}) {
    const scrollRef = useRef<HTMLDivElement>(null);
    const { canScrollStart, canScrollEnd } = useScrollFade(scrollRef);

    return (
        <ReviewsSection>
            <div
                className={`flex items-center ${showHeading ? "justify-between" : "justify-end"}`}
            >
                {showHeading && (
                    <ReviewsHeading className="text-section-title text-balance">
                        What families say
                    </ReviewsHeading>
                )}
                {reviews.length > 1 && (
                    <ReviewsScrollArrows
                        scrollRef={scrollRef}
                        canScrollPrevious={canScrollStart}
                        canScrollNext={canScrollEnd}
                    />
                )}
            </div>
            <ReviewsGrid
                reviews={reviews}
                contextLabel={adoptionLabel}
                scrollRestorationId={
                    organizationId && `provider-reviews-${organizationId}`
                }
                elevated
                scrollRef={scrollRef}
            />

            {organizationId !== undefined && reviewCount > reviews.length && (
                <ReviewsReadMoreLink
                    providerId={organizationId}
                    className="md:w-fit md:min-w-64 md:justify-center md:gap-2.5 md:px-8"
                />
            )}
        </ReviewsSection>
    );
}
